import React, { Component } from "react";
// import DashboardHeader from "../../components/dashboardheader/dashboardheader";
import Finxfooter from "../finxfooter/finxfooter";
import ViewRoles from "../../components/roles/view-roles";
import { connect } from "react-redux";
import * as moment from "moment";
import { bindActionCreators } from "redux";
import { LoginService } from "../../services/login.service";
import AdminHeader from "../../components/dashboardheader/adminheader";
import {
  success,
  successNotification,
  error,
  errorNotification,
  warning,
  warningNotification,
} from "../../components/notification/notifications";

import {
  fetchTermsAndCondition,
  fetchTestInstruction,
} from "../../services/preAssessment.Service";
import {
  getPreAssessmentTermAndCondition,
  getPreAssessmentInstruction,
} from "../../reducer/preAssessmentReducer";
import FeatTest from "../../components/preAssessment/feattest";
import loadable from "@loadable/component";
import LoadingFallback from "../../components/loadingFallBack";

const DashboardHeader = loadable(
  () => import("../../components/dashboardheader/dashboardheader"),
  {
    fallback: <LoadingFallback />,
  }
);

const mapStateToProps = (state) => ({
  termCondition: getPreAssessmentTermAndCondition(state.PreAssessmentReducer),
  testIntroduction: getPreAssessmentInstruction(state.PreAssessmentReducer),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchTermsAndCondition: fetchTermsAndCondition,
      fetchTestInstruction: fetchTestInstruction,
    },
    dispatch
  );

const connectFunction = connect(mapStateToProps, mapDispatchToProps);

const PreAssessment = connectFunction(
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        demo: "demo test",
        termAndCondition: null,
        testIntroduction: null,
        apiCall: true,
        apiCall1: true,
        inboxCount: "",
        notificationEvents1: [],
      };
    }

    componentDidMount() {
      // const dta= this.props
      let partyId = JSON.parse(localStorage.login).partyId;
      var termConditionPayload = {
        productId: this.props.location.state.productId,
        testId: 12,
        userid: partyId,
      };
      this.setState({
        termAndCondition:
          this.props.fetchTermsAndCondition(termConditionPayload),
        testIntroduction: this.props.fetchTestInstruction(termConditionPayload),
      });
    }

    apiCallPropsSet = (value, notificationEvents1) => {
      this.setState({
        apiCall: value,
        notificationEvents1: notificationEvents1,
      });
    };
    apiCallPropsSet1 = (value, inboxCount) => {
      this.setState({ apiCall1: value, inboxCount: inboxCount });
    };

    render() {
      return (
        <React.Fragment>
          <DashboardHeader
            apiCall={this.state.apiCall}
            apiCallPropsSet={this.apiCallPropsSet}
            apiCall1={this.state.apiCall1}
            apiCallPropsSet1={this.apiCallPropsSet1}
            inboxCount={this.state.inboxCount}
            notificationEvents1={this.state.notificationEvents1}
          />

          {/* <ProgressBar {...this.props} /> */}
          <FeatTest {...this.props} />
          <Finxfooter />
        </React.Fragment>
      );
    }
  }
);

export default PreAssessment;
